import get from 'lodash/get';
import { REDUCER_KEY_AI_SEARCH_SUMMARY } from './constants';

// AR-1.0: this is a pure Redux selector taking the chain key as an argument. It does not
// compute staleness or resolve breadcrumbs — that is a hook's job (useSummaryAvailable /
// useSummaryContainer), since breadcrumbs live outside Redux.
export const getSummaryState = (state) => state.get(REDUCER_KEY_AI_SEARCH_SUMMARY);

export const getSummaries = (state, chainKey) => get(getSummaryState(state), ['byChain', chainKey, 'summaries'], []);

export const getLatestSummary = (state, chainKey) => {
  const summaries = getSummaries(state, chainKey);
  return summaries.length ? summaries[summaries.length - 1] : null;
};

export const getSummaryAttempt = (state, chainKey) => get(getSummaryState(state), ['byChain', chainKey, 'attempt'], null);

export const getSummaryById = (state, chainKey, summaryEntryId) =>
  getSummaries(state, chainKey).find((summary) => summary.id === summaryEntryId) || null;
